const LOGOUT_COOKIE = "oransim_account_logout";
const STORAGE_NAMES = ["localStorage", "sessionStorage"] as const;

function cookieValue(name: string): string | null {
  const prefix = `${name}=`;
  const item = document.cookie.split(";").map(part => part.trim()).find(part => part.startsWith(prefix));
  return item === undefined ? null : item.slice(prefix.length);
}
function writeCookie(name: string, value: string | null, maxAge = 604_800): boolean {
  try {
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${name}=${value ?? ""}; Path=/; SameSite=Strict; Max-Age=${value === null ? 0 : maxAge}${secure}`;
    return cookieValue(name) === value;
  } catch { return false; }
}
/** 只检查本产品的非凭据标记；任意值都表示锁定。 */
export function hasLogoutCookie(): boolean { return cookieValue(LOGOUT_COOKIE) !== null; }
export function writeLogoutCookie(locked: boolean): boolean {
  return writeCookie(LOGOUT_COOKIE, locked ? "locked" : null);
}

/** 新 document 无锁证据时确认可持久写入；探测绝不修改实际锁。 */
export function canPersistLock(): boolean {
  const key = `oransim_account_probe_${crypto.randomUUID()}`;
  for (const name of STORAGE_NAMES) {
    let confirmed = false;
    try {
      const storage = window[name];
      storage.setItem(key, "probe");
      confirmed = storage.getItem(key) === "probe";
    } catch { /* 继续检查独立介质。 */ }
    finally {
      try { window[name].removeItem(key); confirmed = confirmed && window[name].getItem(key) === null; }
      catch { confirmed = false; }
    }
    if (confirmed) return true;
  }
  let written = false;
  let removed = false;
  try { written = writeCookie(key, "probe", 60); }
  finally { removed = writeCookie(key, null); }
  return written && removed;
}
